export const ALBUM_MODE_GRID = 'ALBUM_GRID_MODE'
export const ALBUM_MODE_TABLE = 'ALBUM_TABLE_MODE'

export const albumViewGrid = () => ({ type: ALBUM_MODE_GRID })

export const albumViewTable = () => ({ type: ALBUM_MODE_TABLE })
